// extracted by mini-css-extract-plugin
export default {"appButton":"Dialog_appButton__Yt22O"};